import { render, staticRenderFns } from "./den-haag.vue?vue&type=template&id=b4d68344"
import script from "./den-haag.vue?vue&type=script&lang=js"
export * from "./den-haag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports